import { render, staticRenderFns } from "./CalendarWeekView.vue?vue&type=template&id=a36ba622"
import script from "./CalendarWeekView.vue?vue&type=script&lang=js"
export * from "./CalendarWeekView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports